import { useCallback, useEffect, useRef } from "react";
import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import useRouteName from "../../../hooks/useRouteName.js";
const util = createTrackingUtils({
    name: "flights_funnel_sr_airport_tooltip_desktop",
    defaultStage: 1,
    stages: {
        main: 1,
        direct: 2,
        meta: 3,
        long: 4,
        weekend: 5,
        family: 6
    },
    goals: {
        iataClick: 1,
        iataHover: 2,
        iconClick: 3,
        iconHover: 4,
        diff: 5
    }
});
export default function useFlightsFunnelSrAirportTooltipDesktop(cardRef, segments) {
    const routeName = useRouteName();
    const { isDesktop, isDirect, isMeta, isLongHaul, isWeekendStay, isFamily } = useProfiler();
    const trackStages = useCallback(() => {
        if (routeName !== "searchresults")
            return;
        if (!isDesktop())
            return;
        if (isDirect())
            util.stages.direct();
        if (isMeta())
            util.stages.meta();
        if (isLongHaul())
            util.stages.long();
        if (isWeekendStay())
            util.stages.weekend();
        if (isFamily())
            util.stages.family();
    }, [routeName, isDesktop, isDirect, isMeta, isLongHaul, isWeekendStay, isFamily]);
    const getTarget = useCallback((e) => {
        const _ = { iataElm: undefined, iconElm: undefined };
        if (!(e?.target instanceof Element))
            return _;
        const iataElm = e.target.closest('[data-testid^="flight_card_segment_"][data-testid*="_airport_"]') || undefined;
        if (!iataElm)
            return _;
        const iconElm = e.target.closest('[class^="Flyout-module__root"]') || undefined;
        return { iataElm, iconElm };
    }, []);
    const onClick = useCallback((e) => {
        const { iataElm, iconElm } = getTarget(e);
        if (iconElm) {
            util.goals.iconClick();
        }
        else if (iataElm) {
            util.goals.iataClick();
        }
    }, [getTarget]);
    const hoverTimerRef = useRef(null);
    const onHover = useCallback((e) => {
        const { iataElm, iconElm } = getTarget(e);
        if (hoverTimerRef.current)
            clearTimeout(hoverTimerRef.current);
        if (!iataElm && !iconElm)
            return;
        hoverTimerRef.current = setTimeout(() => {
            if (iconElm) {
                util.goals.iconHover();
            }
            else if (iataElm) {
                util.goals.iataHover();
            }
        }, 300);
    }, [getTarget]);
    const trackCP = useCallback(() => {
        if (routeName !== "checkout-payment")
            return;
        if (!segments?.length)
            return;
        if (segments.length === 2 && segments[0].arrivalAirport.code !== segments[1].departureAirport.code) {
            util.goals.diff();
        }
    }, [routeName, segments]);
    useEffect(() => {
        if (!isDesktop())
            return;
        if (!cardRef)
            return;
        if (!cardRef?.current)
            return;
        const card = cardRef.current;
        card.addEventListener("click", onClick);
        card.addEventListener("mouseover", onHover);
        return () => {
            if (hoverTimerRef.current)
                clearTimeout(hoverTimerRef.current);
            card.removeEventListener("click", onClick);
            card.removeEventListener("mouseover", onHover);
        };
    }, [cardRef, onClick, onHover, isDesktop]);
    useEffect(() => {
        trackStages();
    }, [trackStages]);
    useEffect(() => {
        trackCP();
    }, [trackCP]);
    return { trackStages, trackGoals: util.goals };
}
